import { ComponentType } from "react";
import ConfirmationStep from "./components/steps/ConfirmationStep";
import CustomerDetailsStep from "./components/steps/CustomerDetailsStep";
import PaymentStep from "./components/steps/PaymentStep";
import RequestTypeStep from "./components/steps/RequestTypeStep";

export interface StepProps {
    title: string;
    message: string;
    setDisabled?: (isDisabled: boolean) => void; // Optional function to set the disabled state of the next step
}

export interface Step {
    step: number;
    name: string;
    title: string;
    headerTittle: string;
    message: string;
    component: ComponentType<StepProps>;
    isDisabled?: boolean;
}

export const steps: Step[] = [
    {
        step: 1,
        name: "Customer Details",
        title: "Customer Details",
        headerTittle: "Create Service Request",
        message: "Please provide accurate customer information.",
        component: CustomerDetailsStep,

    },
    {
        step: 2,
        name: "Request Type",
        title: "Service Request Type",
        headerTittle: "Service Request Type",
        message: "Select the type of service request, so that the correct workflow, fields and SLA apply",
        component: RequestTypeStep,
    },
    {
        step: 3,
        name: "Confirmation",
        title: "Confirmation",
        headerTittle: "Confirm Details",
        message: "Review your request before submitting.",
        component: ConfirmationStep,
    },
    {
        step: 4,
        name: "Payment",
        title: "Payment",
        headerTittle: "Payment Details",
        message: "Choose preferred payment method",
        component: PaymentStep,
        isDisabled: true, // This step is disabled by default and will be enabled based on the request type selection
    },
];
